/*
 * @Author: cui
 * @Date: 2020-08-03
 * */

import types from "../types";

export default {
  // 登录
  login(context, value) {
    context.commit(types.LOGIN, value);
  },
  // 退出
  logout({ commit }) {
    commit(types.LOGOUT);
  },
  // 打开遮罩层
  openLoading({ commit }) {
    commit(types.OPEN_LOADING);
  },
  // 关闭遮罩层
  closeLoading({ commit }) {
    commit(types.CLOSE_LOADING);
  },
  // 设置网点城市
  setCityName({ commit }, value) {
    commit(types.SET_CITYNAME, value);
  },
};
